import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-grid-inputfilter-renderer',
  template: `
    <input (keypress)="onInput(input)" (change)="onChange($event.target.value)" [(ngModel)]="input" class="form-control" />
  `,
  standalone: false
})
export class InputfilterRendererComponent implements ICellRendererAngularComp {
  params;
  options;
  input;
  onChange;
  onInput;

  agInit(params): void {
    this.params = params;
    this.options = this.params.options ? this.params.options() : null;
    const inputval = this.params.input ? this.params.input() : '';
    this.input = inputval ? inputval : null;
    this.onChange = this.params.onChange;
    this.onInput = this.params.onInput;
    if (this.params.afterLoad) {
      this.params.afterLoad(this.input);
    }
  }

  refresh(params: any): boolean {
    return false;
  }
}
